__turbopack_context__.v({
  "bannerWrapperBoxShadowYellow": "TemplateHeaderBanner-module-scss-module__FlvSxa__bannerWrapperBoxShadowYellow",
});
